//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from "@/javascript/formatDate"
import util from '@/javascript/util'
import goBack from '@/components/public-components/goBack/index.vue'
export default {
  name: "weatherDetails",
  components: {
    goBack
  },
  data () {
    return {
      weatherAir:{},
      minHeight: 0,
      isWeixin: util.isWeiXin(),
      todayData: {},//当前天气情况
      indexData: {},//指数
      forecastData: {},// 预测四天天气气象
      airData: {},//空气质量
      pointData: {},//站点(指向)
      //天气现象对照表
      weatherPhenomenaType: [],
      iconData: [],
      // 风力对照表
      windPower: [],
      // 风向对照表
      windDirection: [],
      // 星期几对照表
      weeks: [
        { code: '0', codeName: '星期日' },
        { code: '1', codeName: '星期一' },
        { code: '2', codeName: '星期二' },
        { code: '3', codeName: '星期三' },
        { code: '4', codeName: '星期四' },
        { code: '5', codeName: '星期五' },
        { code: '6', codeName: '星期六' }
      ],
      weatherTopBg: '',//头部背景图路径
      ww: '',
      mm: '',
      dd: '',
      hh: '',
      min: '',
      addres: "",
      content: "",
      inData: [],
      dailyList: [],
      dailday: [],
      url1: "",
      url2: "",
      url3: "",
      contentText: "",
      temperatureText: "",
      srcArr1: "",
      srcArr2: "",
      srcArr3: "",
      tips: "",
      tipsSearch: "",
    };
  },
  mounted () {
    this.minHeight = document.documentElement.clientHeight;
    this.getdate()
    //初始化天气详情数据
    this.initWeatherData()
  },

  methods: {
    // 获取当前时间
    getdate () {
      var myDate = new Date();
      let mm = myDate.getMonth()
      let ww = myDate.getDay()
      let dd = myDate.getDate()
      let hh = myDate.getHours()
      let min = myDate.getMinutes()
      this.mm = mm + 1
      this.dd = dd
      this.hh = hh
      this.min = min
      switch (ww) {
        case 0: this.ww = '日'
          break;
        case 1: this.ww = '一'
          break;
        case 2: this.ww = '二'
          break;
        case 3: this.ww = '三'
          break;
        case 4: this.ww = '四'
          break;
        case 5: this.ww = '五'
          break;
        case 6: this.ww = '六'
          break;
      }
    },

    //获取天气参照数据
    getWeatherData () {
      return this.$http.get('/static/json/weather/weatherConditionData.json')
    },
    getWeatherlsit () {
      return this.$http.get('/static/json/weather/weathernziconData.json')
    },
    // 获取风力数据
    getWindPowerData () {
      return this.$http.get('/static/json/weather/windPowerData.json')
    },
    // 获取风向数据
    getWindDirectionData () {
      return this.$http.get('/static/json/weather/windDirectionData.json')
    },
    initWeatherData () {
      let _this = this
      _this.$http.all([_this.getWeatherData(), _this.getWindPowerData(), _this.getWindDirectionData(), _this.getWeatherlsit()])
        .then(_this.$http.spread((res1, res2, res3, res4) => {
          this.$set(this, 'weatherPhenomenaType', res1.data)
          this.$set(this, 'windPower', res2.data)
          this.$set(this, 'windDirection', res3.data)
          this.$set(this, 'iconData', res4.data)
          _this.getWeatherDetails()
        }));
    },
    getWeatherDetails () {
      let _this = this

      _this.$http.get('/api/wtcp-weather/public/weather/detail/1/' + '632223').then((res) => {
        this.addres = res.data.data.point.name.substring(0, 2)
      })
      _this.$http.get('/api/wtcp-weather/public/weather/detail/1/' + '632223')
        .then((response) => {
          _this.tips = response.data.data.index.airing_desc
          console.log(response.data, "this.tips");
          if (response.data.data) {
            // 当前天气
            _this.todayData = response.data.data.today
            _this.todayData.update_time = formatDate(_this.todayData.update_time, 'hh:mm')
            _this.weatherBg(_this.todayData.phenomenon)
            // 指数
            _this.indexData = response.data.data.index
            // 预测四天天气
            _this.weatherAir=response.data.data.air
            _this.forecastData = response.data.data.forecast
            let curDate = new Date();
            let curYear = curDate.getFullYear() + '-';
            let curMonth = (curDate.getMonth() + 1 < 10 ? '0' + (curDate.getMonth() + 1) : curDate.getMonth() + 1) + '-';
            let curDay = (curDate.getDate() < 10 ? '0' + curDate.getDate() : curDate.getDate()) + '';
            let curHours = curDate.getHours()
            let dateStr = curYear + curMonth + curDay
            let str1 = _this.formatDate(dateStr, 0)
            let str2 = _this.formatDate(dateStr, 1)
            let str3 = _this.formatDate(dateStr, 2)
            let str4 = _this.formatDate(dateStr, 3)
            let newDate1 = str1.split("-")
            let newDate2 = str2.split("-")
            let newDate3 = str3.split("-")
            let newDate4 = str4.split("-")
            let first_day = newDate1[1] + "月" + newDate1[2] + "日"
            // let week1 = newDate1[3]
            // let week2 = newDate2[3]
            let week3 = newDate3[3]
            let week4 = newDate4[3]
            // let first_week = _this.setWeeks(_this.weeks, week1)
            // let second_week = _this.setWeeks(_this.weeks, week2)
            let third_week = _this.setWeeks(_this.weeks, week3)
            let fourth_week = _this.setWeeks(_this.weeks, week4)
            let second_day = newDate2[1] + "月" + newDate2[2] + "日"
            let third_day = newDate3[1] + "月" + newDate3[2] + "日"
            let fourth_day = newDate4[1] + "月" + newDate4[2] + "日"
            _this.$set(_this.forecastData, 'first_day', first_day)//今天
            _this.$set(_this.forecastData, 'second_day', second_day)//明天
            _this.$set(_this.forecastData, 'third_day', third_day)//第三天
            _this.$set(_this.forecastData, 'fourth_day', fourth_day)//第四天
            _this.$set(_this.forecastData, 'first_week', '今天')//今天是星期几
            _this.$set(_this.forecastData, 'second_week', '明天')//明天星期几
            _this.$set(_this.forecastData, 'third_week', third_week)//第三天是星期几
            _this.$set(_this.forecastData, 'fourth_week', fourth_week)//第四天是星期几
            _this.$set(_this.forecastData, 'timeNode', parseInt(curHours))//白天和晚上天气时间分割点
            _this.setMeteorological(_this.weatherPhenomenaType, _this.forecastData)//天气现象
            _this.setWindPower(_this.windPower, _this.forecastData)//风力
            _this.setWindDirection(_this.windDirection, _this.forecastData)//风向
            // 空气质量
            _this.airData = response.data.data.air
            // 站点
            _this.pointData = response.data.data.point
          }
        })
        .then(() => {

          document.title = '天气预报'
          //   _this.pointData.name +

          /**
           * 微信签名分享
           */
          if (this.isWeixin) {
            const shareData = typeof (shareData) === 'undefined' ? {
              title: _this.pointData.name + '天气',
              desc: _this.SHARE_TEXT,
              imgUrl: _this.weatherTopBg,
              link: window.location.href
            } : shareData;
            // this.$http.get(' /jsTicket?url=' + encodeURIComponent(window.location.href)).then((response) => {
            //     util.initWxConfig(response.data, shareData)
            // })

            this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
              util.initWxConfig(response.data.data, shareData)
            })
          }
        })
    },
    // 星期几
    setWeeks (typeData, weekNum, weekName) {
      typeData.forEach(function (item) {
        if (item.code === weekNum) {
          weekName = item.codeName
        }
      });
      return weekName
    },
    //天数递加
    addDate (date, days) {
      var date = new Date(date)
      date.setDate(date.getDate() + days)
      return date
    },
    //日期格式化
    formatDate (dateStr, days) {
      let date = this.addDate(dateStr, days)
      let curYear = date.getFullYear() + '-';
      let curMonth = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let curDay = date.getDate() + '-';
      let curNum = date.getDay();
      // let curHours = date.getHours() + ':';
      // let curMinutes = date.getMinutes() + ':';
      // let curSeconds = date.getSeconds(); 
      let str = curYear + curMonth + curDay + curNum
      return str
      // let newDate = str.split("-")
      // return newDate[1] + "月" + newDate[2] + "日"
    },
    // 预测四天天气现象
    setMeteorological (typeData, dataSource) {
      for (const attr in dataSource) {
        // 四天白天天气气象start
        if (attr === 'first_day_phenomenon'
          || attr === 'second_day_phenomenon'
          || attr === 'third_day_phenomenon'
          || attr === 'fourth_day_phenomenon') {
          this.phenomenonForEach(typeData, dataSource)
        }
        // 四天白天天气气象end

        // 四天晚上天气气象start
        if (attr === 'first_night_phenomenon'
          || attr === 'second_night_phenomenon'
          || attr === 'third_night_phenomenon'
          || attr === 'fourth_night_phenomenon') {
          this.phenomenonForEach(typeData, dataSource)
        }
        // 四天晚上天气气象end
      }
    },
    // 预测四天风力
    setWindPower (typeData, dataSource) {
      for (const attr in dataSource) {
        // 四天白天风力start
        if (attr === 'first_day_power'
          || attr === 'second_day_power'
          || attr === 'third_day_power'
          || attr === 'fourth_day_power') {
          this.powerForEach(typeData, dataSource)
        }
        // 四天白天风力end

        // 四天晚上风力start
        if (attr === 'first_night_power'
          || attr === 'second_night_power'
          || attr === 'third_night_power'
          || attr === 'fourth_night_power') {
          this.powerForEach(typeData, dataSource)
        }
        // 四天晚上风力end
      }
    },
    // 预测四天风向
    setWindDirection (typeData, dataSource) {
      for (const attr in dataSource) {
        // 四天白天风向start
        if (attr === 'first_day_direction'
          || attr === 'second_day_direction'
          || attr === 'third_day_direction'
          || attr === 'fourth_day_direction') {
          this.directionForEach(typeData, dataSource)
        }
        // 四天白天风向end

        // 四天晚上风向start
        if (attr === 'first_night_direction'
          || attr === 'second_night_direction'
          || attr === 'third_night_direction'
          || attr === 'fourth_night_direction') {
          this.directionForEach(typeData, dataSource)
        }
        // 四天晚上风向end
      }
    },
    phenomenonForEach (typeData, dataSource) {
      typeData.forEach(item => {
        //   console.log(item.code, dataSource.first_day_phenomenon, "====");
        // 四天白天天气气象 start
        if (dataSource.first_day_phenomenon === item.code) {
          this.$set(dataSource, 'first_day_phenomenon_name', item.codeName)
          this.$set(dataSource, 'first_day_weather_icon', item.weatherIconUrl)
        }
        if (dataSource.second_day_phenomenon === item.code) {
          this.$set(dataSource, 'second_day_phenomenon_name', item.codeName)
          this.$set(dataSource, 'second_day_weather_icon', item.weatherIconUrl)
        }
        if (dataSource.third_day_phenomenon === item.code) {
          this.$set(dataSource, 'third_day_phenomenon_name', item.codeName)
          this.$set(dataSource, 'third_day_weather_icon', item.weatherIconUrl)
        }
        if (dataSource.fourth_day_phenomenon === item.code) {
          this.$set(dataSource, 'fourth_day_phenomenon_name', item.codeName)
          this.$set(dataSource, 'fourth_day_weather_icon', item.weatherIconUrl)
        }
        // 四天白天天气气象 end

        // 四天晚上天气气象 start
        if (dataSource.first_night_phenomenon === item.code) {
          this.$set(dataSource, 'first_night_phenomenon_name', item.codeName)
          this.$set(dataSource, 'first_night_weather_icon', item.weatherIconUrl)
        }
        if (dataSource.second_night_phenomenon === item.code) {
          this.$set(dataSource, 'second_night_phenomenon_name', item.codeName)
          this.$set(dataSource, 'second_night_weather_icon', item.weatherIconUrl)
        }
        if (dataSource.third_night_phenomenon === item.code) {
          this.$set(dataSource, 'third_night_phenomenon_name', item.codeName)
          this.$set(dataSource, 'third_night_weather_icon', item.weatherIconUrl)
        }
        if (dataSource.fourth_night_phenomenon === item.code) {
          this.$set(dataSource, 'fourth_night_phenomenon_name', item.codeName)
          this.$set(dataSource, 'fourth_night_weather_icon', item.weatherIconUrl)
        }
        // 四天晚上天气气象 end
      })
    },
    powerForEach (typeData, dataSource) {
      typeData.forEach(item => {
        // 四天白天风力 start
        if (dataSource.first_day_power === item.code) {
          this.$set(dataSource, 'first_day_power_name', item.codeName)
        }
        if (dataSource.second_day_power === item.code) {
          this.$set(dataSource, 'second_day_power_name', item.codeName)
        }
        if (dataSource.third_day_power === item.code) {
          this.$set(dataSource, 'third_day_power_name', item.codeName)
        }
        if (dataSource.fourth_day_power === item.code) {
          this.$set(dataSource, 'fourth_day_power_name', item.codeName)
        }
        // 四天白天风力 end

        // 四天晚上风力 start
        if (dataSource.first_night_power === item.code) {
          this.$set(dataSource, 'first_night_power_name', item.codeName)
        }
        if (dataSource.second_night_power === item.code) {
          this.$set(dataSource, 'second_night_power_name', item.codeName)
        }
        if (dataSource.third_night_power === item.code) {
          this.$set(dataSource, 'third_night_power_name', item.codeName)
        }
        if (dataSource.fourth_night_power === item.code) {
          this.$set(dataSource, 'fourth_night_power_name', item.codeName)
        }
        // 四天晚上风力 end
      })
    },
    directionForEach (typeData, dataSource) {
      typeData.forEach(item => {
        // 四天白天风向 start
        if (dataSource.first_day_direction === item.code) {
          this.$set(dataSource, 'first_day_direction_name', item.codeName)
        }
        if (dataSource.second_day_direction === item.code) {
          this.$set(dataSource, 'second_day_direction_name', item.codeName)
        }
        if (dataSource.third_day_direction === item.code) {
          this.$set(dataSource, 'third_day_direction_name', item.codeName)
        }
        if (dataSource.fourth_day_direction === item.code) {
          this.$set(dataSource, 'fourth_day_direction_name', item.codeName)
        }
        // 四天白天风向 end

        // 四天晚上风向 start
        if (dataSource.first_night_direction === item.code) {
          this.$set(dataSource, 'first_night_direction_name', item.codeName)
        }
        if (dataSource.second_night_direction === item.code) {
          this.$set(dataSource, 'second_night_direction_name', item.codeName)
        }
        if (dataSource.third_night_direction === item.code) {
          this.$set(dataSource, 'third_night_direction_name', item.codeName)
        }
        if (dataSource.fourth_night_direction === item.code) {
          this.$set(dataSource, 'fourth_night_direction_name', item.codeName)
        }
        // 四天晚上风向 end
      })
    },
    //设置天气背景图
    weatherBg (phenomenon) {
      this.weatherPhenomenaType.forEach(item => {
        // 雨
        if (phenomenon === item.codeName && item.typeCode === "1") {
          this.weatherTopBg = "/static/weather/weather-top-bg/rain_bg@2x.png"
        }
        // 雪
        if (phenomenon === item.codeName && item.typeCode === "2") {
          this.weatherTopBg = "/static/weather/weather-top-bg/snow_bg@2x.png"
        }
        // 晴
        if (phenomenon === item.codeName && item.typeCode === "3") {
          this.weatherTopBg = "/static/weather/weather-top-bg/bjt.png"
        }
        // 沙尘、雾霾
        if (phenomenon === item.codeName && item.typeCode === "4") {
          this.weatherTopBg = "/static/weather/weather-top-bg/sandDust_smog@2x.png"
        }
        // 多云
        if (phenomenon === item.codeName && item.typeCode === "5") {
          //   this.weatherTopBg = "/static/weather/weather-top-bg/cloudy_bg@2x.png"
          this.weatherTopBg = "/static/weather/weather-top-bg/bjt.png"
        }
      })
    },
    // 搜索天气
    searchWeather () {
      let content = this.content
      if (content) {
        this.$http.get('/api/wtcp-weather/public/weather/getHfDateil?content=' + content).then((res) => {
          console.log(res.data.data);
          this.inData = res.data.data.air
          this.tipsSearch = res.data.data.air[0].text
          this.dailyList = res.data.data.daily
          this.temperatureText = res.data.data.now.temp
          this.textday = this.iconData.map(item => {
            return item
          })
          this.dailday = this.dailyList.map(may => {
            return may
          })
          this.textday.forEach(item => {
            if (item.code == this.dailday[0].iconDay) {
              this.$set(this, 'url1', item.weatherIconUrl)
            }
            if (item.code == this.dailday[1].iconDay) {
              this.$set(this, 'url2', item.weatherIconUrl)
            }
            if (item.code == this.dailday[2].iconDay) {
              this.$set(this, 'url3', item.weatherIconUrl)
            }
          })

        })
        this.contentText = this.content
      } else {
        return
      }

    },
  }
};
